export function canUseAssistant(auth) {
  const user = auth?.user;
  const roles = user?.roles?.length ? user.roles : [user?.role];
  return Boolean(
    auth?.authenticated &&
      user?.id &&
      !auth.mustChangePassword &&
      !user.mustChangePassword &&
      !user.impersonatedBy &&
      !user.dryRun &&
      !user.driverScope &&
      !user.twoFactorPending &&
      !user.twoFactorSetup &&
      roles.some((role) => ['ADMIN', 'USER'].includes(String(role).toUpperCase())),
  );
}

export function pageContext(location, language, dateCookie) {
  const context = { language: ['en', 'fr', 'it'].includes(language?.split('-')[0]) ? language.split('-')[0] : 'en' };
  if (/^\/admin\/[a-zA-Z0-9/_-]*$/.test(location.pathname) && location.pathname.length <= 200) {
    context.page = location.pathname;
  }
  const order = /^\/admin\/orders\/([a-zA-Z0-9_-]{1,80})\/?$/.exec(location.pathname);
  if (order && !['new', 'upload'].includes(order[1])) context.orderCode = order[1];
  const route = /^\/admin\/routes\/(\d+)\/?$/.exec(location.pathname);
  if (route && Number.isSafeInteger(Number(route[1])) && Number(route[1]) > 0) context.routeId = Number(route[1]);
  // Do not send arbitrary query parameters (tracking/session tokens, etc.).
  const date =
    new URLSearchParams(location.search).get('date') ||
    (location.pathname.startsWith('/admin/route-plans') ? dateCookie : undefined);
  if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) context.date = date;
  return context;
}
